module.exports = __webpack_public_path__ + "static/media/banner.20a89ae6.png";